import {fetchForm, postFormData} from 'utils/asyncUtils'
import * as stringUtils from 'utils/stringUtils'
import {getOIDCUrl} from 'utils/envUtils'
import {INTERACTION_UID} from 'const'

class InteractionService {
  static finishInteraction = async (uid = '') => {
    const interactionUid = uid || stringUtils.getInteractionUid(window.location.search)

    const interactionUrl = `${getOIDCUrl()}/interaction/${interactionUid}/`
    const lang = stringUtils.getLang(window.location.search)

    await postFormData(interactionUrl, {lang})
  }

  static restoreAndFinishInteraction = async () => {
    try {
      const interactionUid = this.getInteractionUid()
      await this.restoreAndCheckInteraction()
      await this.finishInteraction(interactionUid)
    } catch (_) {
      throw new Error('Check and finish Interaction Error')
    }
  }

  static persistInteraction = () => {
    const interactionUid = stringUtils.getInteractionUid(window.location.search)
    if (interactionUid) {
      localStorage.setItem(INTERACTION_UID, interactionUid)
    }
    return interactionUid
  }

  static restoreInteraction = () => {
    const interactionUid = localStorage.getItem(INTERACTION_UID)
    if (interactionUid) {
      localStorage.removeItem(INTERACTION_UID)
    }

    return interactionUid
  }

  static getInteractionUid = () => localStorage.getItem(INTERACTION_UID)

  static restoreAndCheckInteraction = async () => {
    const interactionUid = this.restoreInteraction()
    if (!interactionUid) {
      throw new Error('interaction uid not found')
    }

    const interactionUrl = `${getOIDCUrl()}/interaction/${interactionUid}/`
    await fetchForm(interactionUrl, 'HEAD', undefined, undefined, [404])
  }
}

export default InteractionService
